/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PasswordResetMutationRequest,
  PasswordResetMutationResponse,
} from '../types/PasswordReset'

function getPasswordResetUrl() {
  const res = { method: 'POST', url: `/api/v1/password-reset/` as const }
  return res
}

/**
 * @description Wrapper around dj-rest-auth PasswordResetView for debugging
 * @summary Request a password-reset email
 * {@link /api/v1/password-reset/}
 */
export async function passwordReset(
  data: PasswordResetMutationRequest,
  config: Partial<RequestConfig<PasswordResetMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    PasswordResetMutationResponse,
    ResponseErrorConfig<Error>,
    PasswordResetMutationRequest
  >({
    method: 'POST',
    url: getPasswordResetUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
